import { createFileRoute } from '@tanstack/react-router'
import EditionRoyaltyAndRights from 'Edition/components/sections/General/EditionRoyaltyAndRights/EditionRoyaltyAndRights'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-royalty-levels')({
    component: EditionRoyaltyAndRights,
})
